/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Cli_TitleInputs */

const en_rd_cli_title = /** @type {(inputs: Rd_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to run it offline?`)
};

const id_rd_cli_title = /** @type {(inputs: Rd_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau jalan offline?`)
};

/**
* | output |
* | --- |
* | "Prefer to run it offline?" |
*
* @param {Rd_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_cli_title = /** @type {((inputs?: Rd_Cli_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Cli_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_cli_title(inputs)
	return en_rd_cli_title(inputs)
});